<template>
  <div>
    <h1>Product-led Upsells</h1>
    <div class="p-lg">
      <h2>&lt;BaseUpsell&gt;</h2>
      <BaseUpsell
        v-for="config in baseUpsellConfigs"
        :key="config.key"
        :dismissible="config.dismissible"
        class="mb-lg"
      >
        <template v-slot:icon>
          <HomeIcon class="w-lg h-lg mb-sm" />
        </template>
        <template v-slot:title>
          <div class="mb-5 sm:mb-5">
            <p class="text-black font-bold text-2xl">{{ config.title }}</p>
          </div>
        </template>
        <template v-slot:explainer>
          <div class="mb-5 sm:mb-5">
            <p class="text-black">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris
              scelerisque in ipsum id aliquet. Phasellus sed vestibulum mi. Aenean
              vehicula consectetur felis, non luctus risus interdum quis. Donec
              dolor metus, suscipit tristique ante vel, molestie bibendum quam.
              Sed semper metus at nisi porta, non euismod urna fermentum. Mauris
              quis ornare augue, ac convallis mauris.
            </p>
          </div>
        </template>
        <template v-slot:cta>
          <BaseButton
            variant="primaryDark"
            class="w-full md:w-auto mt-6 text-center">
            Upgrade to plan
          </BaseButton>
        </template>
        <template
          v-slot:media
          v-if="config.hasMedia"
        >
          <WistiaVideo
            mediaId="an9jkn0jo8"
            endBehavior="loop"
            :autoplay="true"
            :muted="true"
          />
        </template>
      </BaseUpsell>
    </div>
    <hr />
    <div class="p-lg">
      <h2>&lt;BulkSendUpsell&gt;</h2>
      <div class="pb-lg">
        <h3>Variation: <code>hasTried=false, canUpgrade=true</code></h3>
        <BulkSendUpsell
          :hasTried="false"
          :canUpgrade="true"
        />
      </div>
      <div class="pb-lg">
        <h3>Variation: <code>hasTried=true, canUpgrade=true</code></h3>
        <BulkSendUpsell
          :hasTried="true"
          :canUpgrade="true"
        />
      </div>
      <div class="pb-lg">
        <h3>Variation: <code>hasTried=false, canUpgrade=false</code></h3>
        <BulkSendUpsell
          :hasTried="false"
          :canUpgrade="false"
        />
      </div>
      <div class="pb-lg">
        <h3>Variation: <code>hasTried=true, canUpgrade=false</code></h3>
        <BulkSendUpsell
          :hasTried="true"
          :canUpgrade="false"
        />
      </div>
    </div>
    <hr />
    <div class="p-lg">
      <h2>&lt;BrandingUpsell&gt;</h2>
      <div class="pb-lg">
        <h3>Variation: <code>brandingData={}, hasTried=false, canUpgrade=true</code></h3>
        <BrandingUpsell
          :brandingData="{}"
          :hasTried="false"
          :canUpgrade="true"
        />
      </div>
      <div class="pb-lg">
        <h3>Variation: <code>brandingData={}, hasTried=true, canUpgrade=true</code></h3>
        <BrandingUpsell
          :brandingData="{}"
          :hasTried="true"
          :canUpgrade="true"
        />
      </div>
      <div class="pb-lg">
        <h3>Variation: <code>brandingData={}, hasTried=false, canUpgrade=false</code></h3>
        <BrandingUpsell
          :brandingData="{}"
          :hasTried="false"
          :canUpgrade="false"
        />
      </div>
      <div class="pb-lg">
        <h3>Variation: <code>brandingData={}, hasTried=true, canUpgrade=false</code></h3>
        <BrandingUpsell
          :brandingData="{}"
          :hasTried="true"
          :canUpgrade="false"
        />
      </div>
    </div>
    <hr />
    <div class="p-lg">
      <h2>&lt;TeamsUpsell&gt;</h2>
      <div class="pb-lg">
        <h3>Variation: <code>hasTried=false, canUpgrade=true</code></h3>
        <TeamsUpsell
          :hasTried="false"
          :canUpgrade="true"
        />
      </div>
      <div class="pb-lg">
        <h3>Variation: <code>hasTried=true, canUpgrade=true</code></h3>
        <TeamsUpsell
          :hasTried="true"
          :canUpgrade="true"
        />
      </div>
      <div class="pb-lg">
        <h3>Variation: <code>hasTried=false, canUpgrade=false</code></h3>
        <TeamsUpsell
          :hasTried="false"
          :canUpgrade="false"
        />
      </div>
      <div class="pb-lg">
        <h3>Variation: <code>hasTried=true, canUpgrade=false</code></h3>
        <TeamsUpsell
          :hasTried="true"
          :canUpgrade="false"
        />
      </div>
    </div>
    <hr />
    <div class="p-lg">
      <h2>&lt;UsersUpsell&gt;</h2>
      <div class="pb-lg">
        <h3>Variation: <code>name=John Doe, hasTried=false, canUpgrade=true</code></h3>
        <UsersUpsell
          name="John Doe"
          :hasTried="false"
          :canUpgrade="true"
        />
      </div>
      <div class="pb-lg">
        <h3>Variation: <code>name=John Doe, hasTried=true, canUpgrade=true</code></h3>
        <UsersUpsell
          name="John Doe"
          :hasTried="true"
          :canUpgrade="true"
        />
      </div>
      <div class="pb-lg">
        <h3>Variation: <code>name=John Doe, hasTried=false, canUpgrade=false</code></h3>
        <UsersUpsell
          name="John Doe"
          :hasTried="false"
          :canUpgrade="false"
        />
      </div>
      <div class="pb-lg">
        <h3>Variation: <code>name=John Doe, hasTried=true, canUpgrade=false</code></h3>
        <UsersUpsell
          name="John Doe"
          :hasTried="true"
          :canUpgrade="false"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { BaseUpsell } from '@/components/library/upsells';
import { HomeIcon } from '@/components/icons/fontIcons';
import { BulkSendUpsell } from '@/components/ui/bulkSend/upsells/BulkSendUpsell';
import { BrandingUpsell } from '@/components/ui/branding/upsells/BrandingUpsell';
import { TeamsUpsell } from '@/components/ui/teams/upsells/TeamsUpsell';
import { UsersUpsell } from '@/components/ui/users/upsells/UsersUpsell';
import BaseButton from '@/components/library/buttons/BaseButton.vue';
import { WistiaVideo } from '@/components/library/video';

export default {
  name: 'BaseUpsellDesign',
  components: {
    BaseUpsell,
    BaseButton,
    HomeIcon,
    BulkSendUpsell,
    BrandingUpsell,
    TeamsUpsell,
    UsersUpsell,
    WistiaVideo,
  },
  data() {
    return {
      baseUpsellConfigs: [
        {
          key: 'non-dismissible',
          dismissible: false,
          title: 'Base Upsell with media (muted video on loop)',
          hasMedia: true,
        },
        {
          key: 'dismissible',
          dismissible: true,
          title: 'Base Upsell - Dismissible with no media',
          hasMedia: false,
        },
      ],
    };
  },
};
</script>
